<div class="main-content">
    <div class="logo bottom-buffer">
        <img src="../assets/images/Nederman-Logo.png" alt="logo">
        <h5>As an user on behalf of
            <span class="companyName">{{customerName}}</span>,
            <br> you are registering for access to Nederman Training Center</h5>
    </div>
    <form class="form form-add form-horizontal" [formGroup]="inputForm" (ngSubmit)="submitForm()">
        <div class="form-group" [ngClass]="{'has-error':!inputForm.controls['email'].valid && isSubmitted}">
            <label class="col-md-4" for="email">E-Mail</label>
            <div class="col-md-8">
                <input type="text" class="inputStyle textInput form-control" name="email" formControlName="email" />
            </div>
            <div *ngIf="!inputForm.controls['email'].valid && isSubmitted" class="validation-msg">You must include a valid email.</div>
        </div>
        <div class="form-group" [ngClass]="{'has-error':!inputForm.controls['firstName'].valid && isSubmitted}">
            <label class="col-md-4" for="firstName">First Name</label>
            <div class="col-md-8">
                <input type="text" class="inputStyle textInput form-control" name="firstName" formControlName="firstName" />
            </div>
            <div *ngIf="!inputForm.controls['firstName'].valid && isSubmitted" class="validation-msg">You must include a first name.</div>
        </div>
        <div class="form-group" [ngClass]="{'has-error':!inputForm.controls['lastName'].valid && isSubmitted}">
            <label class="col-md-4" for="lastName">Last Name</label>
            <div class="col-md-8">
                <input type="text" class="inputStyle textInput form-control" name="lastName" formControlName="lastName" />
            </div>
            <div *ngIf="!inputForm.controls['lastName'].valid && isSubmitted" class="validation-msg">You must include a last name.</div>
        </div>
        <div class="form-group button-separation" [ngClass]="{'has-error':!inputForm.controls['displayName'].valid && isSubmitted}">
            <label class="col-md-4" for="displayName">Display Name</label>
            <div class="col-md-8">
                <input type="text" class="inputStyle textInput form-control" name="displayName" formControlName="displayName" />
            </div>
            <div *ngIf="!inputForm.controls['displayName'].valid && isSubmitted" class="validation-msg">You must include a display name.</div>
        </div>
        <div class="row">
            <div class="col-md-3 pull-right">
                <button class="btn btn-block btn-active">Submit</button>
            </div>
        </div>
    </form>
</div>
<app-spinner #spinner></app-spinner>
<app-error-modal #error="bs-modal"></app-error-modal>
<app-success-modal #success="bs-modal"></app-success-modal>